import api from "api";
import { setDialog, setLoading } from "slices/appSlice";
import { decompressFromUTF16 } from "lz-string";
import {
  WORKFLOW_CONFIGURATION,
  WORKSPACE_CLOB_KEY,
  WORKSPACE_STATUS_TEXT_UPDATE,
} from "../constants/Constants";
import WorkspaceController from "controller/WorkspaceController";
import { convertDxLimitForCantHave } from "./workSpaceFilter";
import { formErrorStrfromObj, isClobValid } from "./shared";
import { postUserActivity } from "components/shared/postUserActivity";

import { validateAndStringifyClob } from "./clobValidation";

export async function initializeWorkspaceController(
  workspaceController,
  setWorkspaceController,
  setWorkspaceLoaded
) {
  if (!workspaceController) {
    const storedWorkspace = localStorage.getItem(WORKSPACE_CLOB_KEY);
    if (storedWorkspace) {
      const decompressed = decompressFromUTF16(storedWorkspace);
      const workspace = JSON.parse(decompressed);
      const workspaceController = new WorkspaceController(
        null,
        null,
        null,
        null,
        workspace
      );
      setWorkspaceController(workspaceController);
    } else {
      console.error(
        "Workspace controller is not available and clob is not stored in session"
      );
    }
  }
  if (setWorkspaceLoaded) setWorkspaceLoaded(true);
}

export async function updatePolicyData(
  dispatch,
  navigate,
  policyState,
  submit,
  workspaceController,
  policyHistoryData,
  ctReviewData,
  updateAssignessReviewerDto,
  policyChangeControlXrefDto,
  workflow,
  activityUpdates
) {
  if (policyChangeControlXrefDto !== null) {
    workspaceController.updateChangeControlForAllRules(
      policyChangeControlXrefDto?.changeControlText
    );
  }
  workspaceController.splitRulesByAdoptionDecision();
  let updatedWorkspace = workspaceController.workspace;
  updatedWorkspace.policyWorkflowTaskCategory =
    policyState.policyWorkflowTaskCategory;
  updatedWorkspace.policyWorkflowTaskStatus =
    policyState.policyWorkflowTaskStatus;

  updatedWorkspace.workspaceClob = convertDxLimitForCantHave(
    workspaceController.clob
  );

  if (updateAssignessReviewerDto?.policyStage == "Configuration") {
    updatedWorkspace.workspaceStatusText = "TRANSFORMED";
  } else {
    updatedWorkspace.workspaceStatusText = WORKSPACE_STATUS_TEXT_UPDATE;
  }

  if (!isClobValid(updatedWorkspace, dispatch)) return; // validation failed, exit early

  // Validate + stringify in one place
  const clobString = validateAndStringifyClob(
    updatedWorkspace.workspaceClob,
    dispatch,
    true
  );
  if (!clobString) return; // validation failed, dialog already shown

  updatedWorkspace.workspaceClob = clobString;
  // Call the API to update the policy coding data
  dispatch(setLoading(true));

  try {
    const response = await api.workspace.updateWorkSpceClob(
      updatedWorkspace,
      submit,
      policyHistoryData,
      ctReviewData,
      updateAssignessReviewerDto,
      policyChangeControlXrefDto
    );

    if (response.status === 200) {
      if (
        response.data.workspace.policyWorkflowTaskStatus.toLowerCase() ===
          "complete" &&
        response.data.workspace.policyWorkflowTaskCategory.toLowerCase() ===
          "translation"
      ) {
        api.workspace
          .transformClob(response.data.workspace.workspaceKey)
          .catch((error) => {
            console.error("Error transforming clob:", error);
          });

        dispatch(
          setDialog({
            message:
              "Transformation rules will be applied to the policy. Please check back later.",
            title: "Submitted",
          })
        );
      }

      try {
        const update = submit ? "Submit" : "Update";
        await postUserActivity(
          workspaceController?.workspace?.healthPlanKey,
          workspaceController?.workspace?.policyKey,
          response.status,
          workflow,
          "click",
          "updatePolicyData",
          update,
          workflow,
          activityUpdates || []
        );
      } catch (error) {
        console.log("Failed to post user activity:", error);
        dispatch(
          setDialog({
            title: "Error",
            message: error.message || "Failed to post user activity",
          })
        );
      }

      localStorage.removeItem(WORKSPACE_CLOB_KEY);
      navigate(-1);
    }
  } catch (e) {
    dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
  } finally {
    dispatch(setLoading(false));
  }
}
